import { gql } from '@apollo/client';
import { USER } from '../fragments';

export const UPSERT_USER = gql`
  mutation upsertUser($input: UpsertUserInput!) {
    user: upsertUser(input: $input) {
      ...user
    }
  }
  ${USER}
`;
